module.exports = __webpack_public_path__ + "img/20.7a1332af.png";